module.exports = "query ($offset: Int = 0, $limit: Int = 1000) {\n  vehicleMakes(offset: $offset, limit: $limit) {\n    items {\n      make\n    }\n  }\n}\n"